import(/* webpackMode: "eager" */ "/web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["LandingView"] */ "/web/src/sections/landing/views/landing-view.tsx");
